export const ReportStatusConst = {
  STARTED: 'started',
  FAILURE: 'failure',
  SUCCESS: 'success',
  IDLE: 'idle',
};
